<!-- firewall-dashboard.component.html -->

<div class="dashboard-wrapper">
	<div *ngIf="isLoading" class="loading-overlay">
		<div class="loading-spinner"></div>
	</div>
	<div class="modal-backdrop" (click)="toggleAll()" *ngIf="showPopup"></div>
	<div class="modal-container image-modal-container" *ngIf="isImageModalOpen">
		<h2 class="modal-title">Image: {{this.orderCurrent.part.partNumber}}</h2>
		<div class="image-modal-content">
			<img [src]="this.orderCurrent.partImage" alt="Enlarged Part Image" />
		</div>
		<div class="modal-actions">
			<button type="button" class="btn-cancel" (click)="toggleImage()">Close</button>
		</div>
	</div>


	<div class="modal-container" *ngIf="showFirewall">
		<h2 class="modal-title">Please Enter Final OK/NOK Count</h2>

		<form (submit)="submitFirewall()" class="modal-form">
			<label>
				OK
				<input type="text" [(ngModel)]="quantityEntered" name="ok" required />
			</label>

			<label>
				NOK
				<input type="text" [(ngModel)]="quantityNok" name="nok" required />
			</label>

			<div class="modal-actions">
				<button type="submit" class="btn-submit">Submit</button>
			</div>
		</form>
	</div>

	<!-- ADD TO ALLOCATION MODAL -->
	<div class="modal-container" *ngIf="showAllocate">
		<h2 class="modal-title">Enter Work Order Id and Quantity</h2>

		<form class="modal-form">
			<label>
				Work Order Id
				<input type="text" [(ngModel)]="allocationWo" name="workOrder" required />
				<br />
				<button class="btn-cancel" style="width:100%; margin-top:20px;" (click)="toggleScan()">Scan Work Order</button>
			</label>

			<label>
				Quantity
				<input type="text" [(ngModel)]="allocationQty" name="qty" required />
			</label>

			<div class="modal-actions">
				<button type="submit" class="btn-submit"
					(click)="assignToAllocations(allocationWo,allocationQty)">Submit</button>
				<button type="button" class="btn-cancel" (click)="toggleAllocate()">Cancel</button>
			</div>
		</form>
	</div>

	<!-- SCAN MODAL -->
	<div class="modal-container" *ngIf="showScan">
		<h2 class="modal-title">Scan Work Order</h2>
		<div class="image-modal-content">
			<zxing-scanner #scanner [formats]="[allowedFormats]" [device]="selectedDevice"
				(camerasFound)="cameraFound($event)" (camerasNotFound)="camerasNotFound()"
				(scanSuccess)="onScanSuccess($event)" >
			</zxing-scanner>
		</div>
		<div class="modal-actions">
			<button type="button" class="btn-cancel" (click)="toggleScan()">Cancel</button>
		</div>
	</div>

	<!-- Change Mode Modal -->
	<div class="modal-container" *ngIf="showMode">
		<h2 class="modal-title">Please Enter Final OK/NOK Count</h2>
		<div class="row">
			<div class="card-grid">
				<div class="dashboard-card" *ngFor="let card of statuses" (click)="changeMode(card.id)"
					style="border-left: 10px solid {{renderStatusColorForModal(card.id)}}">
					<div class="icon-wrapper" style="background-color:{{renderStatusColorForModal(card.id)}}">
						<i class="fas fa-tools"></i>
					</div>
					<div class="card-title">{{ card.name }}</div>
				</div>
			</div>
		</div>
		<div class="modal-actions">
			<button type="button" class="btn-cancel" (click)="toggleMode()">Cancel</button>
		</div>
	</div>
	<!-- Header -->
	<div class="dashboard-header" style="border-left:solid 50px {{this.currentStatusColor}}">
		<div class="header-left">
			<h1>{{this.machine.cellNumber}} ({{this.machine.department}})</h1>
			<div *ngIf="this.orderCurrent?.operatorId != null" class="subheading">
				{{this.orderCurrent?.operatorFullName}}
			</div>
			<div *ngIf="this.orderCurrent?.operatorId == null" class="subheading blink_me warning">No Operator
				Assigned
			</div>
		</div>
		<div class="header-status">
			<span>Status:</span>
			<div class="status-indicator" style="background-color:{{this.currentStatusColor}}">
				{{this.currentStatusText}}</div>
		</div>
	</div>

	<div class="dashboard-content-full" *ngIf="orderCurrent === undefined">
		<div class="no-workorder-panel">
			<i class="fas fa-box-open"></i>
			<p>No Work Order assigned to this cell</p>
		</div>
	</div>

	<!-- Main Content -->
	<div class="dashboard-content" *ngIf="orderCurrent != undefined">
		<!-- Left Panel -->
		<section class="production-info">
			<div class="info-card quantity-progress" style="margin-bottom:24px;">
				<div class="label">QUANTITY COMPLETED / REQUIRED</div>
				<div class="value">{{this.quantityPicked}}/{{this.orderCurrent.quantityOrdered}}</div>
				<div class="progress-bar">
					<div class="progress-fill"
						style="width:{{this.orderCurrent.quantityPicked/this.orderCurrent.quantityOrdered * 100}}%;">
					</div>
				</div>
			</div>
			<div class="columns">
				<!-- Left -->
				<div class="info-column">
					<div class="info-card part-number">
						<div class="label">PART NUMBER</div>
						<div class="value">{{this.orderCurrent.partNumber}}</div>
					</div>
					<div class="info-card client-info">
						<div class="label">CLIENT</div>
						<div class="value">{{this.orderCurrent.clientName}}</div>
					</div>
					<div class="info-card" [class.allocation-number]="this.orderCurrent.allocationId == null"
						[class.blink_me]="this.orderCurrent.allocationId == null"
						[class.operator-info]="this.orderCurrent.allocationId > 0">
						<div class="label">ALLOCATION NUMBER</div>
						<div *ngIf="this.orderCurrent.allocationId > 0" class="value">
							{{this.orderCurrent.allocationId}}
						</div>
						<div *ngIf="this.orderCurrent.allocationId == null" class="value">No Allocation</div>
					</div>
				</div>

				<!-- Right -->
				<div class="info-column">

					<div class="info-card pack-factor">
						<div class="label">PACK FACTOR</div>
						<div class="value">{{this.orderCurrent.part.packFactorExternal}}</div>
					</div>
					<div class="info-card packaging-info">
						<div class="label">PACKAGING</div>
						<div class="value">{{this.orderCurrent.part.packagingExternal.name}}</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Right Panel -->
		<section class="right-panel">
			<!-- Image -->
			<div class="part-image">
				<div class="image-box">
					<img [src]="this.orderCurrent.partImage" alt="part image" (click)="toggleImage()" />
				</div>
			</div>

			<!-- Controls -->
			<div class="controls">
				<div class="control-grid">

					<button class="control-btn green" (click)="createAllocationForEdiOrder(this.orderCurrent.id)"
						*ngIf="(currentStatus==10 && this.orderCurrent.operatorId !== null) && this.orderCurrent.allocationId === null">
						<!-- CREATE ALLOCATION -->
						<i class="fas fa-plus"></i>
					</button>
					<button class="control-btn green" (click)="toggleAllocate()"
						*ngIf="(currentStatus==10 && this.orderCurrent.operatorId !== null) && this.orderCurrent.allocationId !== null && this.orderCurrent.quantityOrdered !== this.quantityPicked">
						<!-- ADD TO ALLOCATION -->
						<i class="fas fa-plus"></i>
					</button>
					<button class="control-btn gray"
						*ngIf="currentStatus!=10 || this.orderCurrent.operatorId === null || this.orderCurrent.quantityOrdered === this.quantityPicked">
						<!-- DEAD -->
						<!-- ADD TO ALLOCATION -->
						<i class="fas fa-plus"></i>
					</button>
					<button class="control-btn green" (click)="setToPicked()"
						*ngIf="currentStatus==10 && this.orderCurrent.operatorId !== null && this.orderCurrent.allocationId !== null && this.quantityPicked >= this.orderCurrent.quantityOrdered">
						<!-- COMPLETE -->
						<i class="fas fa-check-circle"></i>
					</button>
					<button class="control-btn gray"
						*ngIf="currentStatus!=10 || this.orderCurrent.operatorId === null || this.orderCurrent.allocationId === null || this.quantityPicked < this.orderCurrent.quantityOrdered">
						<!-- DEAD -->
						<!-- COMPLETE -->
						<i class="fas fa-check-circle"></i>
					</button>
					<button class="control-btn orange" (click)="toggleSupervisor()" *ngIf="currentStatus!=100">
						<i class="fas fa-engine-warning"></i>
					</button>
					<button class="control-btn pink" (click)="submitStillageRequest()" *ngIf="currentStatus!=100">
						<i class="fas fa-box"></i>
					</button>
					<button class="control-btn purple" (click)="toggleMode()" *ngIf="currentStatus!=100">
						<i class="fas fa-tools"></i>
					</button>
					<button class="control-btn gray" (click)="toggleSupervisor()" *ngIf="currentStatus==100">
						<!-- DEAD -->
						<i class="fas fa-engine-warning"></i>
					</button>
					<button class="control-btn gray" (click)="submitStillageRequest()" *ngIf="currentStatus==100">
						<!-- DEAD -->
						<i class="fas fa-box"></i>
					</button>
					<button class="control-btn gray" (click)="toggleMode()" *ngIf="currentStatus==100">
						<!-- DEAD -->
						<i class="fas fa-tools"></i>
					</button>
					<button class="control-btn blue" (click)="reloadPage();">
						<i class="fas fa-redo-alt"></i>
					</button>
				</div>
			</div>
		</section>
	</div>
</div>